/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OperatorMissedModel { 
    operatorName?: string;
    missedCount?: number;
    totalCount?: number;
    missedPercent?: number;
}

